module.exports = __webpack_public_path__ + "img/ozel-saglik-sigortasi.6269a302.png";